import { render, staticRenderFns } from "./ecgmeterdata.vue?vue&type=template&id=9841b576&"
import script from "./ecgmeterdata.vue?vue&type=script&lang=js&"
export * from "./ecgmeterdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports